<div id="wrap" (click)="screenClick()">
  <div id="innerWrap">
    <div id="closeBtn">
      <span (click)="close($event);">×</span>
    </div>

    <div id="numberWrap">
        <div class="circle active fontSize16">
            1
        </div>

        <div class="line"></div>

        <div class="circle inactive fontSize16">
            2
        </div>

        <div class="line"></div>

      <div class="circle inactive fontSize16">
          3
      </div>
  </div>

  <!--<img id="taskBtn" class="fontSize16 imgAble" (click)="taskBookOut($event)" src="{{assetsRoute}}/picture/casepracticeauthorization/task.png" />-->
  <div id="btnwrap">
  	<div id="taskBtn" class="fontSize16 imgAble" (click)="taskBookOut($event)">任务书</div>
  </div>
  <div id="taskBookBox" [innerHtml]="taskBook" class="fontSize16 lineHeight24">
  </div>

  <div id="shade"></div>

  <div id="closeBtn2" (click)="closeTip($event)"></div>

  <div [@introductionBoxAnimation]="introductionBoxShow ? 'showIntroductionBox' : 'hideIntroductionBox'" id="introductionBox">
      <div id="nameBox" class="fontSize18 lineHeight32"
           [ngClass]="{'nameBox0':currentRole=='秦飞','nameBox1':currentRole=='王立娜','nameBox2':currentRole=='高朗','nameBox3':currentRole=='方科科','nameBox4':currentRole=='季宁'}">
          <span>{{currentRole}}</span>
      </div>
      <div id="introduction" class="fontSize16 lineHeight24" [innerHtml]="currentDescription">

      </div>
  </div>

  <!-- 箭头 -->
  <!-- <img src="{{assetsRoute}}/picture/courselearning/arrow-left.png" (click)="slideRole('right')" alt="" id="arrowLeft"> -->
  <img src="{{assetsRoute}}/picture/courselearning/arrow-right.png" alt="" id="arrowRight">

  <div [@figureAnimation]="figureShow ? 'moveFigure' : 'normalFigure'" style="height: 100%;">
  	<div id="qf" (click)="switchFigure($event)">
  		<img src="{{assetsRoute}}/picture/casepracticeauthorization/qf.png" alt="" >
  	</div>
    <div id="wln" (click)="switchFigure($event)">
  		<img src="{{assetsRoute}}/picture/casepracticeauthorization/wln1.png" alt="" >
  	</div>
  	<div id="gl" (click)="switchFigure($event)">
  		<img src="{{assetsRoute}}/picture/casepracticeauthorization/gl1.png" alt="" >
  	</div>
  	<div id="jn" (click)="switchFigure($event)">
  		<img src="{{assetsRoute}}/picture/casepracticeauthorization/jn1.png" alt="" >
  	</div>
  	<div id="fkk" (click)="switchFigure($event)">
  		<img src="{{assetsRoute}}/picture/casepracticeauthorization/fkk1.png" alt="" >
  	</div>
  </div>
  <div class="chatBox" [@chatBoxAnimation] id="qfChat" *ngIf="chatBoxShow && currentRole == '秦飞'">
    <img src="{{assetsRoute}}/picture/casepracticeauthorization/qf_chat.png" alt=""  class="chatPic">
    <div class="chatText fontSize16 lineHeight24" id="qfChatText">
    </div>
  </div>

  <div class="chatBox" [@chatBoxAnimation] id="wlnChat" *ngIf="chatBoxShow && currentRole == '王立娜'">
    <img src="{{assetsRoute}}/picture/casepracticeauthorization/wln_chat.png" alt=""  class="chatPic">
    <div class="chatText fontSize16 lineHeight24" id="wlnChatText">
    </div>
  </div>


    <div class="chatBox" [@chatBoxAnimation] id="glChat" *ngIf="chatBoxShow && currentRole == '高朗'">
      <img src="{{assetsRoute}}/picture/casepracticeauthorization/gl_chat.png" alt=""  class="chatPic">
      <div class="chatText fontSize16 lineHeight24" id="glChatText">
      </div>
    </div>

    <div class="chatBox" [@chatBoxAnimation] id="jnChat" *ngIf="chatBoxShow && currentRole == '季宁'">
      <img src="{{assetsRoute}}/picture/casepracticeauthorization/jn_chat.png" alt=""  class="chatPic">
      <div class="chatText fontSize16 lineHeight24" id="jnChatText">
      </div>
    </div>

    <div class="chatBox" [@chatBoxAnimation] id="fkkChat" *ngIf="chatBoxShow && currentRole == '方科科'">
      <img src="{{assetsRoute}}/picture/casepracticeauthorization/fkk_chat.png" alt=""  class="chatPic">
      <div class="chatText fontSize16 lineHeight24" id="fkkChatText">
      </div>
    </div>

  <div [@choiceWrapAnimation]="choiceWrapShow ? 'showChoiceWrap' : 'hideChoiceWrap'" id="choiceWrap">
      <div id="choiceTip" class="fontSize16">
        请选择你认为合适的人选（点击头像选择）：
      </div>

      <div class="portraitWrap" id="portraitWrap{{i}}" *ngFor="let role of roles;let i=index">
        <div class="portraitCircle" (click)="selectPeople($event,i)"
             [ngClass]="{'portraitCircle0':role.name=='秦飞','portraitCircle1':role.name=='王立娜','portraitCircle2':role.name=='高朗','portraitCircle3':role.name=='方科科','portraitCircle4':role.name=='季宁','selected':i==selectedPeople}"></div>
        <div class="portraitBtn fontSize16" (click)="peopleReview(i)">
            {{role.name}}的表现
        </div>
      </div>

      <div id="choiceBtn" class="fontSize18" (click)="submitSelectedPeople($event)"
           [ngClass]="{'selectedBtn':selectedPeople>=0,'notSelectedBtn':selectedPeople<0}">
          确定人选
      </div>
  </div>

    <div [@analysisWrapAnimation]="analysisWrapShow ? 'showAnalysisWrap' : 'hideAnalysisWrap'" id="analysisWrap">
        <div id="analysisBtn" class="fontSize18" (click)="goToQuestion($event)">
            整理授权信息
        </div>

        <img src="{{assetsRoute}}/picture/casepracticeauthorization/reviewComment.png"  alt="" id="reviewCommentBtn" class="imgAble">

        <div id="analysisTextBox" class="fontSize16">
            <div id="analysisText">
            </div>
            <div id="analysisTextFake" [innerHtml]="analysisText">
            </div>
            <div id="analysisPortrait">

            </div>
        </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-choice/case-practice-authorization-choice.component.html